import { Typography } from 'antd';

interface IStudentInfoCellProps {
  userName?: string;
  userEmail?: string;
}

export const StudentInfoCell = ({
  userName,
  userEmail
}: IStudentInfoCellProps) => {
  const displayName = userName?.trim() || '-';

  return (
    <div className="min-w-0">
      <Typography.Text strong className="block truncate text-sm">
        {displayName}
      </Typography.Text>
      <Typography.Text type="secondary" className="block truncate text-xs">
        {userEmail || '-'}
      </Typography.Text>
    </div>
  );
};
